import Swiper, { Manipulation, Navigation, Thumbs, Lazy, Pagination } from 'swiper';
import {fadeOutEffect, fadeInEffect, slideUp, slideDown, simulateClick} from './serie-effects.js';

Swiper.use([Manipulation, Navigation, Thumbs, Lazy, Pagination]);

let isMobile = false;

if(window.screen.width >= 1023){
    isMobile = false;
} else {
    isMobile = true;
}

const productFunctions = {
    checkProductIsAvailable: function(){
        let buttonBuy = document.querySelector('.page__product .infos-compra .add-to-cart .add-to-cart-button');

        if( buttonBuy ){
            let target = buttonBuy;
    
            let observer = new MutationObserver((mutations) => {
                if(buttonBuy.textContent == 'Indisponível'){
                    document.querySelector('.page__product .infos-compra-shipping .form-notify').style.display = 'block';
                    document.querySelector('.page__product .infos-compra-shipping .infos-compra').style.display = 'none';

                } else {
                    document.querySelector('.page__product .infos-compra-shipping .form-notify').style.display = 'none';
                    document.querySelector('.page__product .infos-compra-shipping .infos-compra').style.display = 'block';
                }
            });

            let config = { attributes: true, childList: true, characterData: true };
            observer.observe(target, config);
        } 
    },

    installmentsModal: function(){
        let buttonInstallments = document.querySelector('.page__product .product__details .infos-compra-shipping .compra-modal-button');
        let installmentsModal = document.querySelector('.page__product .product__payments');

        const modalClose = (element) => {
            element.addEventListener('click', (event) => {
                fadeOutEffect(  installmentsModal.querySelector('.payments__modal') );
                fadeOutEffect(  installmentsModal.querySelector('.payments__mask') );
    
                buttonInstallments.classList.remove('active');
            });
        }

        const modalOpen = (element) => {
            element.addEventListener('click', (event) => {
                fadeInEffect(  installmentsModal.querySelector('.payments__modal') );
                fadeInEffect(  installmentsModal.querySelector('.payments__mask') );
    
                element.classList.add('active');
            });
        }

        modalOpen( buttonInstallments );

        modalClose( installmentsModal.querySelector('.modal__close') );
        modalClose( installmentsModal.querySelector('.payments__mask') );
    },

    relatedShowcase: function(){
        const productsCarousel = document.querySelectorAll('[data-related-carousel]');

        if(productsCarousel){
            productsCarousel.forEach((section) => {
                const carousel = section.querySelector('.swiper');
                const next = section.querySelector('.swiper-button-next');
                const prev = section.querySelector('.swiper-button-prev');
            
                if (carousel) {
                    new Swiper(carousel, {
                        slidesPerView: 2,
                        loop: false,
                        //lazy load
                        preloadImages: false,
                        lazy: {
                            checkInView: true,
                            loadPrevNext: true,
                            loadOnTransitionStart: true,
                            loadPrevNextAmount: 1,
                        },
                        breakpoints: {
                            1024: {
                                slidesPerView: 4
                            },
                            768: {
                                slidesPerView: 3
                            }
                        },
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        },
                    });
                }
            });
        }
    },

    init: function(){
        const _this = this;

        _this.checkProductIsAvailable();
        _this.installmentsModal();
        _this.relatedShowcase();
    },
}

export default productFunctions;